import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const deliverables = [{
  title: 'El Manual Maestro (PDF)',
  description: 'Paso a paso desde el minuto 1 del despido hasta tu nueva contratación.'
}, {
  title: 'Calculadora de Salida',
  description: 'Para que sepas exactamente cuánto dinero deben depositarte.'
}, {
  title: 'Guiones de Conversación Difícil',
  description: 'Qué decir para negociar una mejor salida sin quemar puentes.'
}, {
  title: 'El CV Antialgoritmo',
  description: 'La estructura exacta que pasa los filtros de software de las grandes empresas.'
}, {
  title: 'Checklist de las Primeras 48 Horas',
  description: 'Las acciones críticas para proteger tu información y tu dinero.'
}];
export function WhatYouGet() {
  return <section className="bg-off-white py-16 px-6" data-id="element-183">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-184">
        <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center text-navy" data-id="element-185">
          Qué Obtienes <span className="text-gold" data-id="element-186">Exactamente</span>
        </h2>

        <div className="space-y-6 mb-12" data-id="element-187">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-lg shadow-md flex items-start gap-4" data-id="element-188">
              <CheckCircleIcon className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-189" />
              <div data-id="element-190">
                <h3 className="font-bold text-xl text-navy mb-2" data-id="element-191">
                  {item.title}
                </h3>
                <p className="text-gray-700" data-id="element-192">{item.description}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-193">
          <CTAButton data-id="element-194">¡QUIERO EL KIT Y PROTEGER MI FUTURO AHORA!</CTAButton>
        </div>
      </motion.div>
    </section>;
}